<div class="flex justify-between">
  <div class="mb-4 flex items-start">
    <aux-input
      class="mr-4 mt-5 w-64"
      placeholder="Search"
      icon="Search"
      iconPosition="left"
      hotKey="/"
      [(ngModel)]="quickFilterText"
      (change)="setTotalRowData()"
    />

    <form class="flex space-x-3" [formGroup]="investigatorSummaryFiltersForm">
      <aux-site-select-dropdown formControlName="site_ids" class="w-64" titleKey="name" />

      <aux-multi-select-dropdown
        placeholder="Select"
        label="Patient ID:"
        formControlName="patient_ids"
        class="mr-3 w-52"
        bindLabel="external_patient_id"
        bindValue="external_patient_id"
        [searchable]="true"
        [items]="(patientOptions$ | async)!"
      />
    </form>
  </div>
  <div class="flex items-center">
    <aux-export-excel-button
      [gridAPI]="gridAPI"
      [getDynamicExcelParamsCallback]="getDynamicExcelParams.bind(this)"
      pendoTag="investigator-summary-excel-export-button"
    />
  </div>
</div>
<div class="relative">
  <ag-grid-angular
    class="ag-theme-aux"
    domLayout="autoHeight"
    [gridOptions]="(gridOptions$ | async)!"
    [rowData]="(gridData$ | async)!"
    [quickFilterText]="quickFilterText"
    (gridReady)="onGridReady($event)"
    (gridSizeChanged)="gridSizeChanged()"
    (sortChanged)="sortChanged$.next(null)"
    auxStickyGrid
  />

  @if ((gridRefresh$ | async) === true) {
    <div class="absolute inset-0 flex bg-white">
      <div class="spinner m-auto h-32 w-32 border-8"></div>
    </div>
  }
</div>
